import state from './state'
export default {
  state,
  mutations: {
    // 活动城市数组
    setActivaityCityList (state, val) {
        state.activaityCityList = val
    }
  },
  actions: {},
  getters: {}
}


// WEBPACK FOOTER //
// ./src/store/aboutCity/index.js